/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-03-26 14:23:39
 * @FilePath: /insuranceagent-ui/src/util/aliyunSlsUtils.js
 * @Description: 阿里云SLS日志服务
 */
import {isBxTest} from '@/config/env'
import {SLS_CLIENT} from '@aliyun-sls/web-browser'

const project = isBxTest() ? 'mbjj-app-log-test-hangzhou' : 'mbjj-app-log-prod-hangzhou'
const logstore = isBxTest() ? 'app-test-raw' : 'app-prod-raw'
const workspace = isBxTest() ? 'app-test' : 'app-prod'
const env = isBxTest() ? 'test' : 'prod'

/**
 * 初始化SLS
 */
export function initSLS() {
	SLS_CLIENT.init({
		host: 'cn-hangzhou.log.aliyuncs.com', // 实例所绑定的Project的访问域名。
		project: project, // 实例所绑定的Project，测试生产不同
		logstore: logstore, //  Logstore名称。创建实例后，日志服务会自动生成一个名为{instance}-raw的Logstore，测试生产不同
		workspace: workspace, // 工作空间名称，即实例ID，测试生产不同
		env: env, // 自定义环境，测试生产不同
		service: 'IE-BAO-PC', //自定义服务名称
		enableRuntimeError: false, // 上报JS错误和资源加载错误。
		enableResourcePerf: false, // 上报资源性能数据。
		enableRequest: true, // 上报API请求数据。
		enablePerf: true, // 上报页面加载性能数据。
		enableTrace: true, // 上报前后端链路追踪数据。
		ignoreRequestConfig: [
			//忽略请求
			(url, status) => {
				return (
					/^.*\/event$|^.*\.css$/.test(url) ||
					(status === 200 && /^https:\/\/rrlog\..+\/r\.png|\/employer\/login\/scanstatus$/.test(url))
				)
			},
		],
	})
}
